<script lang="ts">
    import { onMount } from 'svelte';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';
    import Loader from '$saga/components/Loader.svelte';
    import { filtersContext } from '$saga/views/Search/store';
    import {
        getFilterChangeHandler,
        resetLabels,
        resetValues,
    } from '$saga/views/Search/utils';

    export let searchResultTotal: number | null,
        searchDatalayer: string = '';

    const debouncedHandleFilterChange = getFilterChangeHandler();

    onMount(() => {
        if (searchResultTotal && searchResultTotal === 0 && window.dataLayer) {
            window.dataLayer.push(JSON.parse(searchDatalayer));
        }
    });

    const resetFilters = () => {
        $filtersContext.formLabels = resetLabels();
        $filtersContext.formValues = resetValues();

        debouncedHandleFilterChange();
    };
</script>

{#if $filtersContext.isSubmitting}
    <div class="self-center text-center">
        <Loader />
    </div>
{:else if searchResultTotal}
    <div class="text-xl font-semibold desktop:text-2xl text-center">
        <span class="placeholder italic text-content-brand">
            {trans('search.counter.count', {
                '%count%': searchResultTotal,
            })}
        </span>
        <span>
            {trans('search.counter.suffix', {
                '%count%': searchResultTotal,
            })}
        </span>
        {#if $filtersContext.formValues.keywords}
            <span>
                {trans('search.counter.for_keywords', {
                    '%keywords%': String($filtersContext.formValues.keywords),
                })}
            </span>
        {/if}
    </div>
{:else if searchResultTotal != null && searchResultTotal === 0}
    <div
        class="mb-2xl flex flex-col items-center justify-center gap-m bg-white p-l desktop:justify-start"
    >
        <span class="text-center">
            {trans('search.counter.no_results')}
            {#if $filtersContext.formValues.keywords}
                {trans('search.counter.for_keywords', {
                    '%keywords%': String($filtersContext.formValues.keywords),
                })}
            {/if}
        </span>

        <Button size="small" shape="rounded" onclick={resetFilters}>
            {trans('search.counter.reset_filters')}
        </Button>
    </div>
{/if}
